var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75,14.8a1.21,1.21,0,0,0-.86.31,1,1,0,0,0,0,1.56,1.21,1.21,0,0,0,.86.31,1.23,1.23,0,0,0,.86-.31,1.06,1.06,0,0,0,0-1.56A1.23,1.23,0,0,0,11.75,14.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.84,7.39A3.22,3.22,0,0,0,9.6,8.1a2.62,2.62,0,0,0-.81,2H11a1.17,1.17,0,0,1,.25-.76.78.78,0,0,1,.62-.29c.56,0,.84.33.84,1a1.17,1.17,0,0,1-.25.73,4.41,4.41,0,0,1-.72.73,2.32,2.32,0,0,0-.69.94,4.29,4.29,0,0,0-.21,1.49h1.84a2.27,2.27,0,0,1,.14-.81,1.7,1.7,0,0,1,.43-.62l.75-.69a3.28,3.28,0,0,0,.68-.9,2.19,2.19,0,0,0,.21-1,2.31,2.31,0,0,0-.79-1.89A3.37,3.37,0,0,0,11.84,7.39Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.ac8eba084f540dd7fa7e2b1c02431790.svg";
export { ForwardRef as ReactComponent };